export const UPDATE_OLD_PASSWORD = 'resetPasswordWithOldPassword/UPDATE_OLD_PASSWORD'
export const UPDATE_NEW_PASSWORD = 'resetPasswordWithOldPassword/UPDATE_NEW_PASSWORD'
export const UPDATE_CONFIRM_PASSWORD = 'resetPasswordWithOldPassword/UPDATE_CONFIRM_PASSWORD'
export const UPDATE_IS_RESET = 'resetPasswordWithOldPassword/UPDATE_IS_RESET'
export const UPDATE_ERROR_MESSAGE = 'resetPasswordWithOldPassword/UPDATE_ERROR_MESSAGE'